// @ts-nocheck
import { Routes, Route } from 'react-router-dom';
import CalendarPage from './CalendarPage';
import WorkflowPage from './WorkflowPage';
import EditorPage from './EditorPage';
import DataTablesPage from './DataTablesPage';
import FormBuilderPage from './FormBuilderPage';
import WidgetsRoutes from './WidgetsPage';

export default function AdvancedRoutes() {
  return (
    <Routes>
      <Route path="calendar" element={<CalendarPage />} />
      <Route path="workflow" element={<WorkflowPage />} />
      <Route path="editor" element={<EditorPage />} />
      <Route path="data-tables" element={<DataTablesPage />} />
      <Route path="form-builder" element={<FormBuilderPage />} />
      <Route path="widgets/*" element={<WidgetsRoutes />} />
    </Routes>
  );
}
